import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

export const NoAccess = () => {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center "
    >
      <Icon className="fas fa-ban" color="neutral.300" fontSize="xxl" mb="16" />

      <Text variant="cardTitle" mb="16">
        Access Unavailable
      </Text>

      <Text color="neutral.500">You don&apos;t have permission to access this page.</Text>
      <Text color="neutral.500">Please reach out to your advisor.</Text>
    </Box>
  );
};
